import { Link } from "react-router-dom";
import { ShieldCheck, Lock } from "lucide-react";
import { FaWhatsapp, FaInstagram, FaFacebookF } from "react-icons/fa";
import {
  CLINIC_WHATSAPP,
  CLINIC_PHONES,
  CLINIC_DOMAIN,
  CLINIC_DOMAIN_URL,
  CLINIC_EMAIL,
  CLINIC_ADDRESS,
  CLINIC_HOURS,
  CLINIC_LANGUAGES,
} from "@/lib/clinic";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-clinic-pine text-clinic-bg mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-heading text-2xl tracking-tight">The Dental Clinic</div>
          <div className="text-[11px] tracking-[0.2em] uppercase text-clinic-bg/70 mt-1">by Dr. Ashish Kumar</div>
          <a href={CLINIC_DOMAIN_URL} className="block mt-3 text-clinic-bg/80 text-sm hover:text-white">{CLINIC_DOMAIN}</a>
          <p className="mt-6 text-clinic-bg/80 max-w-md leading-relaxed">
            A calm, modern dental clinic in the heart of Siwan. Premium dentistry rooted in evidence, gentleness, and craft.
          </p>
          <div className="flex gap-3 mt-6">
            <a href={`https://wa.me/${CLINIC_WHATSAPP}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="w-10 h-10 rounded-full grid place-items-center border border-clinic-bg/30 hover:bg-clinic-bg hover:text-clinic-pine transition">
              <FaWhatsapp />
            </a>
            <a href="#" className="w-10 h-10 rounded-full grid place-items-center border border-clinic-bg/30 hover:bg-clinic-bg hover:text-clinic-pine transition" data-testid="footer-instagram"><FaInstagram /></a>
            <a href="#" className="w-10 h-10 rounded-full grid place-items-center border border-clinic-bg/30 hover:bg-clinic-bg hover:text-clinic-pine transition" data-testid="footer-facebook"><FaFacebookF /></a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-clinic-bg/60">Visit</div>
          <p className="mt-4 text-clinic-bg/85 leading-relaxed text-sm">
            {CLINIC_ADDRESS.line1},<br />{CLINIC_ADDRESS.line2}<br />
            <span className="text-clinic-bg/65">{CLINIC_ADDRESS.landmark}</span>
          </p>
          <div className="text-xs uppercase tracking-[0.2em] text-clinic-bg/60 mt-6">Hours</div>
          <p className="mt-3 text-clinic-bg/85 text-sm leading-relaxed">
            Open all 7 days<br />{CLINIC_HOURS.days} · {CLINIC_HOURS.time}
          </p>
          <div className="text-xs uppercase tracking-[0.2em] text-clinic-bg/60 mt-6">Languages</div>
          <p className="mt-3 text-clinic-bg/85 text-sm">{CLINIC_LANGUAGES.join(" · ")}</p>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.2em] text-clinic-bg/60">Reach</div>
          <ul className="mt-4 space-y-2 text-clinic-bg/85 text-sm">
            {CLINIC_PHONES.map((p) => (
              <li key={p.tel}><a href={`tel:${p.tel}`} className="hover:text-white">{p.display}</a></li>
            ))}
            <li>{CLINIC_EMAIL}</li>
          </ul>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center gap-2 text-xs bg-clinic-bg/10 px-3 py-1.5 rounded-full">
              <ShieldCheck size={14} /> SSL Secured
            </span>
            <span className="inline-flex items-center gap-2 text-xs bg-clinic-bg/10 px-3 py-1.5 rounded-full">
              <Lock size={14} /> Stripe Payments
            </span>
          </div>
          <Link to="/admin" data-testid="footer-admin-link" className="block mt-6 text-xs text-clinic-bg/60 hover:text-clinic-bg underline">
            Clinic Admin
          </Link>
        </div>
      </div>
      <div className="border-t border-clinic-bg/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row gap-3 items-center justify-between text-xs text-clinic-bg/60">
          <div>© {new Date().getFullYear()} The Dental Clinic by Dr. Ashish Kumar. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-clinic-bg">Privacy</a>
            <a href="#" className="hover:text-clinic-bg">Terms</a>
            <a href="#" className="hover:text-clinic-bg">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
